module.exports = __webpack_public_path__ + "img/communication14.557096d7.png";